import { render, staticRenderFns } from "./QuickTutorial.vue?vue&type=template&id=28e504b5"
import script from "./QuickTutorial.vue?vue&type=script&lang=js"
export * from "./QuickTutorial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports